import { ReactElement } from 'react';
import { CloudCostsHistoryContainer } from '../../../../modules/cloudCosts/containers/CloudCostsHistory.container';

export const CloudCostsHistoryView = (): ReactElement => <CloudCostsHistoryContainer />;
